import useSWR from "swr"
import { followCreator as follow } from "./followCreator"
import { unfollowCreator as unfollow } from "./unfollowCreator"
import { getIsFollowing } from "./getIsFollowing"
import { AxiosError } from "axios"

const baseKey = "USE_CREATOR_FOLLOW"

export const useCreatorFollow = (
  userId: string,
  isAuthed: boolean,
): {
  isFollowing: boolean | undefined
  error: AxiosError | undefined
  followCreator: () => Promise<void>
  unfollowCreator: () => Promise<void>
} => {
  const {
    data: isFollowing,
    error,
    mutate,
  } = useSWR(`${baseKey}/${userId}/${isAuthed}`, async () => {
    if (!isAuthed) {
      return false
    }

    return getIsFollowing(userId)
  })

  const followCreator = async () => {
    return follow(userId).then(() => {
      mutate(true, false)
    })
  }

  const unfollowCreator = async () => {
    return unfollow(userId).then(() => {
      mutate(false, false)
    })
  }

  return {
    isFollowing,
    error,
    followCreator,
    unfollowCreator,
  }
}
